import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GlobalSearchService } from './globalsearchservice.service';

export interface OcmNormalized {
	name_combined: string;
	entity_name: string;
	dba: string;
	short_name: string;
	license_number: string;
	license_type: string;
	license_type_label: string;
	license_status: string;
	operational_status: string;
	expiration_date: string;
	address_line_1: string;
	address_line_2: string;
	city: string;
	state: string;
	zip_code: string;
	county: string;
	region: string;
	primary_contact: string;
	business_website: string;
	is_active: boolean;
	is_operational: boolean;
	is_expired: boolean;
}

export interface OcmMetrcProbeResult {
	ok: boolean;
	full_license: string | null;     // bare + winning Metrc suffix (what to store in metrc_recipient_license)
	suffix: string | null;            // just the suffix (e.g. "-D1")
	candidates_tried: string[];
	last_error?: string | null;
	dry_run?: boolean;
	error?: string;                   // present when Metrc config blocked the probe entirely
}

export interface OcmLookupResponse {
	success: boolean;
	ok?: boolean;
	found?: boolean;
	cached?: boolean;
	license_number?: string;
	normalized?: OcmNormalized;
	raw?: Record<string, unknown>;
	metrc_probe?: OcmMetrcProbeResult;
	error?: string;
}

@Injectable({ providedIn: 'root' })
export class OcmService {
	private config: any;
	private user: any = [];

	constructor(private http: HttpClient, private globalSearchService: GlobalSearchService) {
		this.globalSearchService.configsubscription.subscribe(r => { this.config = r; });
		this.globalSearchService.user.subscribe(result => { this.user = result; });
	}

	lookup(licenseNumber: string, opts: { refresh?: boolean; probeMetrc?: boolean } = {}): Observable<OcmLookupResponse> {
		// apiServer.endpoint already includes `?route=apir/`, so the path passed
		// to endpoint() must NOT re-add the `apir/` prefix (would double it).
		return this.http.get<OcmLookupResponse>(this.endpoint('ocm/lookup', {
			license_number: licenseNumber,
			refresh: opts.refresh ? 1 : '',
			probe_metrc: opts.probeMetrc ? 1 : '',
		}));
	}

	private endpoint(path: string, query: { [k: string]: any } = {}): string {
		const base = this.config.apiServer.endpoint;
		const sep = base.indexOf('?') === -1 ? '?' : '&';
		const parts: string[] = this.authPairs();
		Object.keys(query).forEach(k => {
			const v = query[k];
			if (v === null || v === undefined || v === '') return;
			parts.push(encodeURIComponent(k) + '=' + encodeURIComponent(String(v)));
		});
		const tail = parts.length ? sep + parts.join('&') : '';
		return base + path + tail;
	}

	private authPairs(): string[] {
		const pkg = this.globalSearchService.getSessionItem('package');
		const userid = this.user && this.user.user ? this.user.user.userid : '';
		const pairs = [
			'key=' + encodeURIComponent(this.config.apiCredentials.clientId),
			'userid=' + encodeURIComponent(String(userid))
		];
		if (pkg) {
			pairs.push('package=' + encodeURIComponent(String(pkg)));
		}
		return pairs;
	}
}
